import { ChangeEvent, useState } from "react";
import { InputType } from "../../../types/input"
import FormInput from "../../inputs/FormInput"
import Button from "../../buttons/Button";
import { ButtonSize, ButtonType, ButtonVariant } from "../../../types/button";
import api from "../../../newApi/apiNet";
import { useNotification } from "../../../providers/NotificationProvider";
import { NotificationStatus } from "../../notification/Notification";
import axios from "axios";

export const AccountManagementDeleteUser = () => {
    const _notificationService = useNotification();

    const [customerId, setCustomerId] = useState<number | null>(null);
    const handleCustomerIdInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        setCustomerId(Number(e.target.value));
    }
    const handleDeleteUserButtonClick = async () => {
        if (customerId) {
            if (confirm(`Czy na pewno chcesz usunąć użytkownika z ID: ${customerId}?`)) {
                try {
                    await api.deleteUser(customerId.toString());
                    setCustomerId(null);
                    _notificationService.showNotification("Użytkownik usunięty", "Użytkownik został pomyślnie usunięty.", NotificationStatus.success);
                } catch (e) {
                    console.log(e);
                    if (axios.isAxiosError(e) && e.response) {
                        if (e.response.status === 400 && e.response.data.MsgCode === "USER_NOT_FOUND") {
                            _notificationService.showNotification(
                                "Niepowdzenie",
                                "Użytkownik z takim ID nie istnieje.",
                                NotificationStatus.failure
                            );
                        }
                        else {
                            _notificationService.showNotification(
                                "Błąd",
                                "Wystąpił błąd podczas usuwania użytkownika. Spróbuj ponownie.",
                                NotificationStatus.failure
                            );
                        }
                    }
                    else {
                        _notificationService.showNotification(
                            "Błąd",
                            "Wystąpił błąd podczas usuwania użytkownika. Spróbuj ponownie.",
                            NotificationStatus.failure
                        );
                    }
                }
            }
        }
    }
    return (
        <div className='max-w-lg animate-opacityEaseIn'>
            <div className={"bg-neutral-900 p-6 md:p-10 max-w-lg shadow-3xl rounded-3xl"}>
                <h1 className='text-3xl mb-3 font-medium'>Usuń użytkownika</h1>
                <div className="h-0.5 w-28 bg-sky-500 my-4 rounded-r-full" />
                <FormInput
                    label={"id użytkownika"}
                    name={"password"}
                    onInputChange={handleCustomerIdInputChange}
                    type={InputType.NUMBER}
                    value={customerId?.toString() || ""}
                    placeholder={"Wpisz id użytkownika"}
                    className={"bg-neutral-600 ring-offset-neutral-900 py-2"}
                />
                <Button
                    type={ButtonType.BUTTON}
                    size={ButtonSize.BASE}
                    variant={ButtonVariant.PRIMARY}
                    onClick={handleDeleteUserButtonClick}
                    className={"mx-auto block w-full py-1.5 text-lg mt-4"}
                >Usuń</Button>
            </div>
        </div>
    )
}
